module.exports = __webpack_public_path__ + "img/icon_logo@2x.679b0d5c.png";